import * as React from "react";
import { observer } from "mobx-react-lite";
import type { TextProps } from "@chakra-ui/react";
import { Text as ChakraText } from "@chakra-ui/react";
import { colors } from "../../theme/colors";

export type TextPreset = "preset2" | "preset3" | "preset4";

export interface IPropsText extends TextProps {
	preset: TextPreset;
	fontWeight: "light" | "medium" | "normal" | "regular";
	isHighlight?: boolean;
}

/**
 ** fontSizes m = mobile | d = desktop

 * preset2 = m: 14px d: 16px |
 * preset3 = m: 16px d: 18px |
 * preset4 = m: 18px d: 20px |
 */

export const Text: React.FC<IPropsText> = observer((props) => {
	const {
		children,
		preset,
		fontWeight,
		lineHeight,
		isHighlight,
		...textProps
	} = props;

	const selectedTextSize = React.useMemo(
		() => {
			switch (preset) {
				case "preset2":
					return "sm";
				case "preset3":
					return "md";
				case "preset4":
					return "lg";
			}
		},
		[preset],
	);

	const selectedFontWeight = React.useMemo(
		() => {
			switch (fontWeight) {
				case "regular":
					return "normal";
				case "light":
				case "medium":
				case "normal":
					return fontWeight;
				default:
					return fontWeight;
			}
		},
		[fontWeight],
	);

	return (
		<ChakraText
			size={selectedTextSize}
			fontWeight={selectedFontWeight}
			lineHeight={lineHeight}
			color={isHighlight ? colors.black : undefined}
			{...textProps}
		>
			{children}
		</ChakraText>
	);
});
